class Locale {
  locale
  defaultConstants = {
    name: 'Название',
    images: 'Изображения',
    price: 'Цена',
    contacts: 'Контакты',
    print: 'Печать',
    panorama: 'Панорама',
    'online-qrcode': 'Посмотреть презентацию онлайн',
    'application-name': 'Имя',
    'application-phone': 'Телефон',
    'application-comment': 'Комментарий',
    'something-went-wrong': 'Что-то пошло не так',
    'application-has-been-sent': 'Заявка отправлена',
    'sign-up-for-viewing': 'Записаться на просмотр',
    'table-version': 'Табличная версия',
    'print-version': 'Версия для печати',
    'your-agent': 'Ваш агент',
    'personal-offer': 'Персональное предложение',
    'lead-id': 'ID сделки',
  }

  constructor(locale) {
    this.locale = locale
  }

  getConstantTranslationByKey(key) {
    return (
      this.locale?.presentation?.constants?.find((c) => c.target === key)
        ?.translation || this.defaultConstants[key]
    )
  }
  getTranslatedParam(param) {
    let translatedParam = param

    this.locale?.general?.forEach((g) => {
      translatedParam = translatedParam.replaceAll(g.target, g.translation)
    })

    return translatedParam
  }
}

export default Locale
